import { supabase } from './supabaseClient' // Import Supabase client

const AuthContextService = {
  login: async (method, ...args) => {
    if (method === 'email') {
      const [email, password, keepLogin] = args
      const { error } = await supabase.auth.signInWithPassword({
        email: email,
        password: password,
        options: {
          persistSession: keepLogin,
        },
      })

      if (error) {
        throw new Error(error.message || 'Email login failed')
      }
    } else {
      const { error } = await supabase.auth.signInWithOAuth({
        provider: method,
      })

      if (error) {
        throw new Error(`Login method ${method} is failed`)
      }
    }
  },
  signUp: async (data, navigate) => {
    const formData = {
      full_name: data.fullName,
      date_of_birth: data.dateOfBirth,
      country: data.country,
      age_range: data.age,
      organization: data.organizationName,
    }

    const {
      data: { user },
      error: signUpError,
    } = await supabase.auth.signUp({
      email: data.email,
      password: data.password,
      options: {
        data: formData,
      },
    })

    if (signUpError) {
      throw new Error(signUpError.message)
    }

    const { error: insertError } = await supabase.from('users').insert([
      {
        id: user.id,
        email: data.email,
        ...formData,
      },
    ])

    if (insertError) {
      throw new Error(insertError.message)
    }

    await AuthContextService.login('email', data.email, data.password, false)

    navigate('/create-avatar')
  },
}

export default AuthContextService
